
import axios from "axios";
import env from "react-dotenv";
const SERVERBASEURL = process.env.REACT_APP_API;
const config = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Content-Type": "application/json",
  },
};

export async function getDispatchPlans() {
  const dispatchPlansList = await axios.get(
    SERVERBASEURL + "/dispatch-orders",
    config
  );
  return dispatchPlansList.data.data;
}

export async function getDispatchPlansForPO(id) {
  const dispatchPlansList = await axios.get(
    SERVERBASEURL + `/dispatch-orders/${id}`,
    config
  );
  return dispatchPlansList.data.data;
}

export async function getDispatchPlansDetails(id) {
  const dispatchPlansList = await axios.get(
    SERVERBASEURL + `/dispatch-order-details/${id}`,
    config
  );
  console.log('API Response for details:', dispatchPlansList.data);
  return dispatchPlansList.data.data;
}
export async function getDispatchOrderDetailsForEditing(dispatchOrderId) {
  const dispatchPlan = await axios.get(
    SERVERBASEURL + `/dispatch-order-details-for-editing/${dispatchOrderId}`,
    config
  );
  return dispatchPlan.data.data;
}

export async function setDispatchOrderStatus(data) {
  const d = await axios.post(
    SERVERBASEURL + "/set-dispatch-order",
    data,
    config
  );
  return d;
}

export async function insertGrade(data) {
  const savedStatus = await axios.post(
    SERVERBASEURL + "/material-grade-rate",
    JSON.stringify(data),
    config
  );
  return savedStatus;
}

export async function updateGrade(data) {
  console.log(data);
  const savedStatus = await axios.put(
    SERVERBASEURL + `/material-grade-rate/${data.id}`,
    data,
    config
  );
  return savedStatus;
}

export async function deleteGrade(id) {
  const deleteStatus = await axios.delete(
    SERVERBASEURL + `/material-grade-rate/${id}`,
    config
  );
  return deleteStatus;
}

export async function getAvailableQuantity(id) {
  const availableQuantity = await axios.get(
    SERVERBASEURL + `/get-available-quantity/${id}`,
    config
  );
  console.log("getAvailableQuantity" + JSON.stringify(availableQuantity));
  return availableQuantity.data.data;
}

export async function getInvoicesForDispatchMaterial(dispatchMaterialId) {
  const invoices = await axios.get(
    SERVERBASEURL + `/invoices/${dispatchMaterialId}`,
    config
  );
  console.log("dispatchMaterialId" + JSON.stringify(invoices.data.data));
  return invoices.data.data;
}

export async function getInvoice(invoiceName) {
  const invoices = await axios.get(
    SERVERBASEURL + `/download-invoice/${invoiceName}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/pdf",
      },
    }
  );
  console.log("invoice" + JSON.stringify(invoices?.data));
  return invoices?.data;
}

export async function getSalesOrderFile(salesOrderFileName) {
  const salesOrder = await axios.get(
    SERVERBASEURL + `/download/sales-order/${salesOrderFileName}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/pdf",
      },
    }
  );
  console.log("salesOrder" + JSON.stringify(salesOrder.data.data));
  return salesOrder.data;
}

export async function getTillDateDispatch() {
  const dispatchQuantity = await axios.get(
    SERVERBASEURL + `/till-date-dispatch`,
    config
  );
  // console.log("getTillDateDispatch"+JSON.stringify(dispatchQuantity));
  return dispatchQuantity.data.data;
}

export async function getPendingOrderQuantity() {
  const dispatchQuantity = await axios.get(
    SERVERBASEURL + `/pending-order-quantity`,
    config
  );
  // console.log("getPendingOrderQuantity"+JSON.stringify(dispatchQuantity));
  return dispatchQuantity.data.data;
}

export async function updateDispatchedQuantity(data, dispatchMaterialId) {
  // console.log(data,"   ,",dispatchMaterialId);
  const savedStatus = await axios.put(
    SERVERBASEURL + `/quantity-dispatched/${dispatchMaterialId}`,
    data,
    config
  );
  return savedStatus;
}
// In your dispatchPlan.js service file
// export async function getDispatchOrderList(page = 1, limit = 10) {
//   config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
//   const d = await axios.get(
//     SERVERBASEURL + `/all-dispatch-orders?page=${page}&limit=${limit}`,
//     config
//   );
//   return d;
// }


// DP_DATE_FILTER : Accepts the applied date range and appends it to the DP listing API request while preserving existing status and search filters.
export async function getDispatchOrderList(page = 1, limit = 10, status = -1, searchTerm = '', start_date = '', end_date = '') {
  console.log('Service: getDispatchOrderList called with:', { page, limit, status, searchTerm, start_date, end_date });
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  let url = SERVERBASEURL + `/all-dispatch-orders?page=${page}&limit=${limit}`;
  
  if (status !== -1) {
    url += `&status=${status}`;
  }
  
  if (searchTerm && searchTerm.trim() !== '') {
    url += `&search=${encodeURIComponent(searchTerm.trim())}`;
  }

  // DP_DATE_FILTER : Adds the start and end dates to the listing request only when both dates are provided.
  if (start_date && end_date) {
    url += `&start_date=${encodeURIComponent(start_date)}&end_date=${encodeURIComponent(end_date)}`;
  }
  
  console.log('Service: Request URL:', url);
  
  try {
    const d = await axios.get(url, config);
    console.log('Service: Response received! Status:', d.status);
    console.log('Service: Response data:', d.data);
    return d;
  } catch (error) {
    console.error('Service: Error:', error.message);
    throw error;
  }
}
export async function getOtherStateParity() {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`
  const d = await axios.get(
    SERVERBASEURL + "/master/other-state-parity",
    config
  );
  return d;
}

export async function getExPlantRates() {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`
  const d = await axios.get(
    SERVERBASEURL + "/master/ex-plant-rates",
    config
  );
  return d;
}
// Update this function
export async function getSAPDataForDispatchPlan(refNo) {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  try {
    const response = await axios.get(
      SERVERBASEURL + `/sap-data/${refNo}`,
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching SAP data:', error);
    return { status: 0, data: {} };
  }
}

// DP_DATE_FILTER : Accepts the applied date range and sends it with the selected status when requesting the DP Excel report.
export async function getDispatchPlanReport(status, start_date = '', end_date = '') {
  // DP_DATE_FILTER : Appends the date range to the report URL so the downloaded Excel report uses the same filter as the listing.
  const report = await axios.get(
    SERVERBASEURL + `/download/dp-report/${status}?start_date=${encodeURIComponent(start_date)}&end_date=${encodeURIComponent(end_date)}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "application/pdf",
      },
    }
  );
  // console.log("dispatchPlanReport" + JSON.stringify(report.data));
  return report;
  
}
// Add this function
export async function updateDispatchMaterialWithSAP(dispatchMaterialId, sapData) {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  try {
    const response = await axios.put(
      SERVERBASEURL + `/dispatch-material/${dispatchMaterialId}/update-sap`,
      sapData,
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error updating dispatch material with SAP:', error);
    return { status: 0, message: error.message };
  }
}

// Add this function
export async function updateDispatchPlanWithSAP(dispatchPlanId, sapData) {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  try {
    const response = await axios.put(
      SERVERBASEURL + `/dispatch-plan/${dispatchPlanId}/update-sap`,
      sapData,
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error updating dispatch plan with SAP:', error);
    return { status: 0, message: error.message };
  }
}
// Add this function
// Update this function
export async function saveSAPData(dispatchPlanId, sapData) {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  try {
    console.log('Sending to backend:', {
      url: SERVERBASEURL + `/dispatch-plan/${dispatchPlanId}/save-sap`,
      data: sapData
    });
    
    const response = await axios.post(
      SERVERBASEURL + `/dispatch-plan/${dispatchPlanId}/save-sap`,
      sapData,
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error saving SAP data - Full error:', error);
    console.error('Error response:', error.response?.data);
    console.error('Error status:', error.response?.status);
    return { 
      status: 0, 
      message: error.response?.data?.message || error.message 
    };
  }
}

export async function syncSingleDispatchPlanWithSAP(id) {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  try {
    const response = await axios.post(
      SERVERBASEURL + `/dispatch-plan/${id}/sync-sap`,
      {},
      config
    );
    return response.data;
  } catch (error) {
    console.error('Error syncing SAP for DP:', error);
    return { status: 0, message: error.response?.data?.message || error.message };
  }
}
